<template>
    <div id="TravelGeo" class="starter-template" :key="key">
        <b-container fluid>
            <b-row class="text-center" style="padding-top: 6px">
                <b-col>
                    <div class="text-center shad">
                        <h4 class="txtShad">{{ $t('TRAVELS') }}</h4>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <GeoChooser
                v-on:getGeoTo="getGeoTo"
                :key="myKey"
                v-if="geoChooser"
                ref="getGeoTo"
                v-bind:chooserName="chToName"
                v-bind:scope=scope
                v-bind:retOnce=false
        />
        <br>
        <b-container fluid>
            <b-row >
                <b-col>
                    <div class="tbl1Name shad">
                        <h4 class="txtShad text-center">{{ $t('SETS') }}</h4>
                    </div>
                    <b-table class="backWhite descOuter mt-2"
                             id="listTableT"
                             responsive
                             selectable
                             :items="itemsT"
                             :fields="fields"
                             :per-page=0
                             :current-page="curPageT"
                             striped
                             head-row-variant="info"
                             @row-selected="onRowSelectedT"
                    >
                    </b-table>

                    <b-pagination v-if="listLengthT>10"
                                  v-model="curPageT"
                                  :total-rows="rowsT"
                                  :per-page="perPage"
                                  aria-controls="listTableT"
                                  pills
                    ></b-pagination>
                </b-col>
                <b-col>
                    <div class="tbl1Name shad">
                        <h4 class="txtShad text-center">{{ $t('PLACES') }}</h4>
                    </div>
                    <b-table class="backWhite descOuter mt-2"
                             id="listTableP"
                             responsive
                             selectable
                             :items="itemsP"
                             :fields="fields"
                             :per-page=0
                             :current-page="curPageP"
                             striped
                             head-row-variant="info"
                             @row-selected="onRowSelectedP"
                    >
                    </b-table>
                    <b-pagination v-if="listLengthP>10"
                                  v-model="curPageP"
                                  :total-rows="rowsP"
                                  :per-page="perPage"
                                  aria-controls="listTableP"
                                  pills
                    ></b-pagination>
                </b-col>
            </b-row>
            <br><br><br>
        </b-container>

        <b-container fluid class="footer text-center">
            <b-row>
                <b-col>
                    <span  v-b-popover.hover.top="this.$t('MAP')" @click="areaMap()"  v-if="countryEn">
                        <font-awesome-icon icon="globe" size="lg"/>
                    </span>
                </b-col>

                <b-col v-if="curUserName=='admin'">
                <b-form-checkbox-group>
                    <b-form-checkbox class="m-1" v-model="untieGeo" value="true">
                            <span  v-b-popover.hover.top="this.$t('UNTIE')">
                                <font-awesome-icon icon="unlink" size="lg"/>
                            </span>
                    </b-form-checkbox>
                    <b-button class="m-1">
                            <span  v-b-popover.hover.top="this.$t('DEL_GEO')" @click="$bvModal.show('modal-del')">
                                <font-awesome-icon icon="trash-alt" size="lg"/>
                            </span>
                    </b-button>
                </b-form-checkbox-group>
                </b-col>
            </b-row>


        </b-container>

    </div>
</template>

<script>
import { BContainer, BRow, BCol, BButton, BTable, BPagination,
    BFormCheckbox, BFormCheckboxGroup } from 'bootstrap-vue';
import GeoChooser from "./GeoChooser.vue";

export default {
  name: 'TravelGeo',
  components: {
    GeoChooser,
    BContainer, BRow, BCol, BButton, BTable, BPagination, BFormCheckbox, BFormCheckboxGroup
  },
  data: function() {
    return {
        key: 0,
        userName: '',
        curUserName: '',
        itemName: '',
        itemType: '',
        countryRu: '',
        countryEn: '',
        districtRu: '',
        districtEn: '',
        cityRu: '',
        cityEn: '',
        sightRu: '',
        sightEn: '',
        intLoc: this.$i18n.locale,
        item: '',
        itemsT: [{}],
        selectedT: null,
        listLengthT: 1,
        perPage: 10,
        curPageT: 1,
        itemsP: [{}],
        selectedP: null,
        listLengthP: 1,
        curPageP: 1,
        itemsO: [{}],
        geoType: '',
        chsnGeo: '',
        untieGeo: false,
        showMapBtn: false,
        individ: 'false',
        fixOld: false,
        geoChooser: true,
        myKey: 0,
        chToName: 'whereTo',
        scope: 'travels',
        title: '',
        metaDesc: ''
    }
  },
  metaInfo() {
     return {
        title: `${this.title}`,
        meta: [
            { vmid: 'description', name: 'description', content: this.metaDesc },
        ]
     }
  },
  beforeMount() {
    this.curUserName = this.$store.state.curUserName;
    this.descMeta();
  },
  methods: {
    async getGeoTrips() {
        if(!this.geoType) return;
        try {
            const response = await this.$http.get('/getGeoTrips', {
                params: {
                    geoType: this.geoType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    sightRu: this.sightRu,
                    sightEn: this.sightEn,
                    listLoc: this.intLoc,
                    pageNum: this.curPageT
                }
            });
            this.itemsT = response.data.itemList;
            this.listLengthT = response.data.listLen;
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('TravelGeo: getGeoTrips() '+error.message);
            this.$showErr(error.response.data, error.response.status);
        }
    },
    async getGeoPlaces() {
        if(!this.geoType) return;
        try {
            const response = await this.$http.get('/getGeoPlaces', {
                params: {
                    geoType: this.geoType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    sightRu: this.sightRu,
                    sightEn: this.sightEn,
                    listLoc: this.intLoc,
                    pageNum: this.curPageP
                }
            });
            this.itemsP = response.data.itemList;
            this.listLengthP = response.data.listLen;
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('TravelGeo: getGeoPlaces() '+error.message);
            this.$showErr(error.response.data, error.response.status);
        }
    },
    chListLoc(newListLoc) {
        this.intLoc = newListLoc;
        this.curPageT = 1;
        this.curPageP = 1;
        this.curPageO = 1;
        /*
        this.selCountryRu = 'Россия';
        this.selCountryEn = 'Russia';
        this.selDistrictRu = '';
        this.selDistrictEn = '';
        this.selCityRu = '';
        this.selCityEn = '';
        */
        this.itemsT = [];
        this.itemsP = [];
    },
    onRowSelectedT(items) {
        this.item = items[0];
        this.itemType = 't';
        if(this.untieGeo) this.$bvModal.show('modal-untie');
        else {
            this.$router.push({
                path: '/Tour/'+this.$addEncHyp(this.item.itemName)+'/'+this.$addEncHyp(this.item.userName),
            })
        }
    },
    onRowSelectedP(items) {
        this.item = items[0];
        this.itemType = 'p';
        if(this.untieGeo) this.$bvModal.show('modal-untie');
        else {
        this.$router.push({
            path: '/Place/'+this.$addEncHyp(this.item.itemName)+'/'+this.$addEncHyp(this.item.userName),
        })
        }
    },
    clear() {
        this.countryRu = '',
        this.countryEn = '',
        this.districtRu = '',
        this.districtEn = '',
        this.cityRu = '',
        this.cityEn = '',
        this.sightRu = '',
        this.sightEn = '',
        this.geoType = '';
        this.itemsT = [{}];
        this.itemsP = [{}];
        this.listLengthT = 0;
        this.listLengthP = 0;
    },
    areaMap() {
        if(!this.countryEn) return;
        let country = this.countryEn;
        let district = this.districtEn ? this.districtEn : '_';
        let city = this.cityEn ? this.cityEn : '_';
        //console.log(country, district, city);
        this.$router.push({
            //name: 'AreaMap',
            //name: 'AreaMap', params: { country: country, district: district, city: city }
            path: '/Map/AreaMap/'+country+'/'+district+'/'+city
        })
    },
    async untie() {
        this.$bvModal.hide('modal-untie');
        this.untieGeo = false;
        //console.log(this.item.userName, this.item.itemName, this.item.itemType);
        try {
            const response = await this.$http.get('/refDel', {
                params: {
                    userName: this.item.userName,
                    itemName: this.item.itemName,
                    itemType: this.itemType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    sightRu: this.sightRu,
                    sightEn: this.sightEn,
                    intLoc: this.intLoc
                }
            });
            this.$showMsg(response.data);
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    getGeoTo() {
        let chosenGeo = this.$refs.getGeoTo.getChosenGeo();
            if(chosenGeo.init) this.clear();
            if(!chosenGeo.countryEn) return;
            this.countryRu = chosenGeo.countryRu;
            this.countryEn = chosenGeo.countryEn;
            this.districtRu = chosenGeo.districtRu;
            this.districtEn = chosenGeo.districtEn;
            this.cityRu = chosenGeo.cityRu;
            this.cityEn = chosenGeo.cityEn;
            this.sightRu = chosenGeo.sightRu;
            this.sightEn = chosenGeo.sightEn;
            //console.log(this.countryRu, this.districtRu, this.cityRu);
            if(this.sightEn) this.geoType = 'sight';
            else if(this.cityEn) this.geoType = 'city';
            else if(this.districtEn) this.geoType = 'district';
            else this.geoType = 'country';
            this.getGeoTrips();
            this.getGeoPlaces();
    },
    async del() {
        this.$bvModal.hide('modal-del');
        try {
            const response = await this.$http.get('/rmGeoItem', {
                params: {
                    refType: this.geoType,
                    countryRu: this.countryRu,
                    countryEn: this.countryEn,
                    districtRu: this.districtRu,
                    districtEn: this.districtEn,
                    cityRu: this.cityRu,
                    cityEn: this.cityEn,
                    sightRu: this.sightRu,
                    sightEn: this.sightEn
                }
            });
            this.$showMsg(response.data);
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    descMeta() {
        if(this.$i18n.locale === 'ru') {
            this.title = 'Путешествия и достопримечательности';
            this.metaDesc = 'Каталог путешествий и достопримечательностей по странам и городам';
        }
        else {
            this.title = 'Travels and attractions'
            this.metaDesc = 'Directory of travels and attractions by countries and cities';
        }
    }
  },
  watch: {
    '$store.state.intLoc': function() {
        this.intLoc = this.$store.state.intLoc;
        this.key++;
        this.clear();
        //this.getCountries();
    },
    curPageT: function() {
        if(!this.init) this.getGeoTrips();
    },
    curPageP: function() {
        if(!this.init) this.getGeoPlaces();
    }
  },
  computed: {
    rowsT() {
        return this.listLengthT;
    },
    rowsP() {
        return this.listLengthP;
    },
    fields() {
      return [
        { key: 'itemName', label:  this.$t('TITLE') },
        { key: 'userName', label: this.$t('AUTHOR') },
        //{ key: 'pubDate', label: this.$t('DATE_PUB') }
      ]
    },
  }
}

</script>

<style>
</style>